"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseClassName = void 0;
var ParseClassName;
(function (ParseClassName) {
    ParseClassName["ATTACHMENT"] = "Attachment";
    ParseClassName["CALIBRATION"] = "Calibration";
    ParseClassName["CAPTURE_FILE"] = "CaptureFile";
    ParseClassName["COLLECTION"] = "FormData";
    ParseClassName["COLLECTION_SUMMARY"] = "CollectionSummary";
    ParseClassName["ANNOTATION"] = "AnnotationSummary";
    ParseClassName["DEPARTMENT"] = "Company";
    ParseClassName["DEVICE"] = "Device";
    ParseClassName["FORM"] = "Form";
    ParseClassName["HISTORY_COLLECTION"] = "history_FormData";
    ParseClassName["HISTORY_DEVICE"] = "history_Device";
    ParseClassName["HISTORY_FORM"] = "history_Form";
    ParseClassName["HISTORY_USER"] = "history__User";
    ParseClassName["ORG"] = "Org";
    ParseClassName["ROLE"] = "_Role";
    ParseClassName["SCHEMA"] = "Schema";
    ParseClassName["SCHEMA_FIELD"] = "SchemaField";
    ParseClassName["SCHEMA_METADATA"] = "SchemaMetadata";
    ParseClassName["SCHEMA_REVISION"] = "SchemaRevision";
    ParseClassName["SESSION"] = "_Session";
    ParseClassName["TAG"] = "Job";
    ParseClassName["TIMING_EVENT"] = "TimingEvent";
    ParseClassName["TOKEN"] = "Token";
    ParseClassName["USER"] = "_User";
    ParseClassName["VERIFY"] = "Verify";
    ParseClassName["VERSION"] = "Version";
})(ParseClassName || (exports.ParseClassName = ParseClassName = {}));
//# sourceMappingURL=parse.class.name.js.map